import type { Route } from 'vue-router'
import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum, FilterIdEnum } from '../../enums'
import ExplainProductAnalysis from '../../views/explain/explain-product-analysis/explain-product-analysis.view.vue'
import ExplainQueryAnalysis from '../../views/explain/explain-query-analysis/explain-query-analysis.view.vue'
import ExplainSearch from '../../views/explain/explain-search.view.vue'
import Explain from '../../views/explain/explain.view.vue'
import { ROUTER_CONSTS } from '../router.consts'

const meta: AppRouteConfig['meta'] = {
  featureId: FeatureIdEnum.EXPLAIN,
  filters: () => ({
    regularFiltersEnabled: true,
    config: {
      [FilterIdEnum.DATE]: {
        enabled: true,
        mandatory: true,
      },
    },
    initiallyHidden: true,
  }),
}

export const EXPLAIN_ROUTES: Array<AppRouteConfig> = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].landing,
    path: 'explain',
    component: Explain,
    meta: {
      featureId: FeatureIdEnum.EXPLAIN,
      filters: () => ({
        regularFiltersEnabled: true,
        config: {
          [FilterIdEnum.REALTIME]: {
            enabled: true,
            mandatory: true,
            intervalsInMinutes: [15, 60, 12 * 60],
          },
        },
        initiallyHidden: true,
      }),
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].search,
    path: 'explain/search',
    component: ExplainSearch,
    meta,
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].queryAnalysis,
    path: 'explain/queryAnalysis',
    component: ExplainQueryAnalysis,
    meta,
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.EXPLAIN].productAnalysis,
    path: 'explain/productAnalysis/:productId',
    component: ExplainProductAnalysis,
    meta,
  },
]

export function isExplainRoute(route: Route): boolean {
  return (
    !!route.name &&
    Object.values(EXPLAIN_ROUTES)
      .map(routeConfig => routeConfig.name)
      .includes(route.name)
  )
}
